<div>
  <div class="loading-screen-wrapper" *ngIf="loadingService.loadingStatus | async">
    <div class="loading-screen-icon">
      <div class="dashboard-loader"></div>
    </div>
  </div>

  <div *ngIf="userService.user && !isLoginLayout(); else default">
    <mat-toolbar>
      <app-header [user]="userService.user" (toggleMenu)="toggleMenu()"></app-header>
    </mat-toolbar>
    <mat-sidenav-container>
      <mat-sidenav #drawer mode="over" opened="false" role="navigation">
        <app-sidebar></app-sidebar>
      </mat-sidenav>
      <mat-sidenav-content>
        <div class="container__content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>

  <ng-template #default>
    <router-outlet></router-outlet>
  </ng-template>
</div>